import React from "react";
import Logo from './logo.svg';

const StoreLogo = () => <img src={Logo} alt="logo"/>;

export default StoreLogo;
